export default __webpack_public_path__ + "static/media/icons8-increase.0fb06034.svg";